import * as React from "react";
import { motion } from "framer-motion";

export function Example() {
  return (
    <div
      style={{
        width: 601,
        height: 601,
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        backgroundSize: "150px 150px",
        backgroundImage:
          "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
        display: "flex",
        placeItems: "center",
        placeContent: "center"
      }}
    >
      <motion.div
        style={{
          width: 80,
          height: 80,
          borderRadius: 10,
          backgroundColor: "#fff",
          cursor: "grab"
        }}
        drag
        dragConstraints={{ top: -300, right: 300, bottom: 300, left: -300 }}
        dragTransition={{
          power: 0.5,
          timeConstant: 100,
          modifyTarget: (target) => Math.round(target / 150) * 150
        }}
        whileTap={{ cursor: "grabbing" }}
      />
    </div>
  );
}
